import React from "react";

function TextArea({ type = "textarea", placeholder = "", name = "", value= "", onChange }) {
    return (
        <>
            <textarea className="form-control contact-form" placeholder={placeholder} name={name} value={value} onChange={onChange} required />
        </>
    )
}

export default TextArea;